import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DefaultListRefreshState, IListRefreshState, RefreshableList } from './listRefreshState';

const initialState: IListRefreshState = DefaultListRefreshState;

/** API resources whose writes can change a row shown in each list table. */
const LIST_RESOURCES: Record<RefreshableList, RegExp> = {
  plans: /^(plan|jurisdictions|responses|timeline)\b/,
  projects: /^project\b/
};

/**
 * The Plans and Projects tables stay mounted (hidden) while one of their entries is
 * viewed or edited, so they no longer reload just because the user came back.
 * `dataSaved` is dispatched for every successful write (see services/apiFetch) and
 * bumps the counter of each list that write can affect; the list passes its counter
 * to the table, which reloads its rows in place when the counter changes.
 */
export const listRefreshSlice = createSlice({
  name: 'listRefresh',
  initialState,
  reducers: {
    dataSaved: (state, action: PayloadAction<{ url: string }>) => {
      (Object.keys(LIST_RESOURCES) as RefreshableList[]).forEach((list) => {
        if (LIST_RESOURCES[list].test(action.payload.url)) state[list] += 1;
      });
    }
  }
});

export const { dataSaved } = listRefreshSlice.actions;

export default listRefreshSlice.reducer;
